var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 12C9.53757 12 12 9.53757 12 6.5C12 3.46243 9.53757 1 6.5 1C3.46243 1 1 3.46243 1 6.5C1 9.53757 3.46243 12 6.5 12ZM6.5 13C10.0899 13 13 10.0899 13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97363 2.89062L6.91016 7.99316H6.09473L6.02637 2.89062H6.97363ZM5.99707 9.5459C5.99707 9.39941 6.04102 9.27572 6.12891 9.1748C6.22005 9.07389 6.35352 9.02344 6.5293 9.02344C6.70182 9.02344 6.83366 9.07389 6.9248 9.1748C7.01921 9.27572 7.06641 9.39941 7.06641 9.5459C7.06641 9.68587 7.01921 9.80632 6.9248 9.90723C6.83366 10.0081 6.70182 10.0586 6.5293 10.0586C6.35352 10.0586 6.22005 10.0081 6.12891 9.90723C6.04102 9.80632 5.99707 9.68587 5.99707 9.5459Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.14852d721fae7bc40209d1509129d6db.svg";
export { ForwardRef as ReactComponent };